/* eslint-disable class-methods-use-this */
import { authHttp } from './BaseRequest';

export interface IGetPasswordToken {
  // eslint-disable-next-line camelcase
  username: string;
  // eslint-disable-next-line camelcase
  password: string;
}

class AuthServiceHelper {
  getPasswordToken(data: IGetPasswordToken) {
    const params = new URLSearchParams();

    params.append('grant_type', 'password');
    params.append(
      'client_id',
      process.env.REACT_APP_TUTOPIYA_CLIENT_ID as string
    );

    params.append(
      'client_secret',
      process.env.REACT_APP_TUTOPIYA_CLIENT_SECRET as string
    );

    if (data.username) {
      params.append('username', data.username);
    }

    if (data.password) {
      params.append('password', data.password);
    }

    return authHttp
      .post('/oauth/token', params)
      .then((res) => res.data)
      .catch((err) => {
        return Promise.reject(new Error(JSON.stringify(err.response)));
      });
  }

  getClientCredentialToken() {
    const params = new URLSearchParams();

    params.append('grant_type', 'client_credentials');
    params.append(
      'client_id',
      process.env.REACT_APP_TUTOPIYA_CLIENT_ID as string
    );

    params.append(
      'client_secret',
      process.env.REACT_APP_TUTOPIYA_CLIENT_SECRET as string
    );

    return authHttp.post('/oauth/token', params).then((res) => res.data);
  }
}

export default new AuthServiceHelper();
